const defaultMessage = {
  filterSettingHeaderTitle: 'Filters',
  searchLabel: 'Search by note',
  assigneeLabel: 'Assignee',
  clientLabel: 'Client',
  assignmentLabel: 'Assignment Status',
  claimantLabel: 'Claimant',
  dateFrom: 'Due Date From',
  dateTo: 'Due Date To',
  reset: 'Reset'
};

export default defaultMessage;
